import { SectionGridItem } from 'common/components/SectionGrid/SectionGridItem';
import { SectionGridRow } from 'common/components/SectionGrid/SectionGridRow';
import { useTranslation } from 'react-i18next';
import { DisplaySection } from '../../Sim/Details/DisplaySection';
import { SectionLoader } from '../../Sim/Details/SectionLoader';

export type DeviceData = {
  imei?: string | null;
  managementIpAddress?: string | null;
  currentIpAddress?: string | null;
  apn?: string | null;
  activeConfiguration?: string | null;
};

export type OrderSectionProps = {
  deviceData: DeviceData;
  isLoading?: boolean;
};

export const DeviceSection = ({ deviceData, isLoading }: OrderSectionProps) => {
  const { t } = useTranslation();

  return (
    <SectionLoader isLoading={isLoading} data-testid="device-details-section-skeleton">
      <DisplaySection
        data={deviceData}
        keys={['imei', 'managementIpAddress', 'currentIpAddress', 'apn', 'activeConfiguration']}
      >
        <SectionGridRow title={t('simInventory.device')} data-testid="deviceSection">
          <>
            <SectionGridItem
              value={deviceData?.imei}
              label={t('simInventory.detectedImei')}
              testId="imei"
            />
            <SectionGridItem
              value={deviceData?.managementIpAddress}
              label={t('simInventory.managementIp')}
              testId="managementIpAddress"
            />
            <SectionGridItem
              value={deviceData?.currentIpAddress}
              label={t('products.sim.lastKnownIP')}
              testId="currentIpAddress"
            />
            <SectionGridItem value={deviceData?.apn} label={t('simInventory.apn')} testId="apn" />
            <SectionGridItem
              value={deviceData?.activeConfiguration}
              label={t('simInventory.activeConfiguration')}
              testId="activeConfiguration"
            />
          </>
        </SectionGridRow>
      </DisplaySection>
    </SectionLoader>
  );
};
